import { METRIC_TYPES, MetricType } from '../config/chart-config';

import { MetricsDataPoint } from './revenue-metrics-chart';

import { TabType } from '@/routes/dashboards/shared-types';

import { eventMetrics } from '../config/chart-config';

export const getMetricsForTab = (tab: TabType, data: MetricsDataPoint[]): MetricType[] => {
  switch (tab) {
    case 'revenue':
      return [METRIC_TYPES.LIFECYCLE_REVENUE, METRIC_TYPES.FLOWS_REVENUE];
    case 'directRevenue':
      return [METRIC_TYPES.FLOWS_REVENUE, METRIC_TYPES.LIFECYCLE_REVENUE];
    case 'influencedRevenue':
      return [METRIC_TYPES.FLOWS_REVENUE, METRIC_TYPES.LIFECYCLE_REVENUE];
    case 'anonVisitors':
      return [METRIC_TYPES.ANON_VISITORS_RECOGNIZED];
    case 'events': {
      return eventMetrics.filter((metric) =>
        data.some((point) => {
          const value = point[metric];
          return value !== undefined && value > 0;
        })
      );
    }

    default:
      return [];
  }
};
